import {defaultConfig, get} from "./action.service";
import moment from 'moment';
import axios, { AxiosRequestConfig } from 'axios';
import { Auth } from "aws-amplify";
import * as _ from 'lodash';

export const getLastValues = async() => {
    const user = await Auth.currentAuthenticatedUser();

    return axios.get('/GetLatestData', _.assign(defaultConfig, {
        headers: {
            'Content-Type': 'application/json',
            'username': user.username
        }
    })).then((res) => {
        return Promise.resolve(convertResponseLine(res.data.values));
    })
}

const convertResponseLine = (data: string) => {
    const dataArray = data.split(',');
    return {
        relay1: dataArray[0],
        relay2: dataArray[1],
        relay3: dataArray[2],
        relay4: dataArray[3],
        relay5: dataArray[4],
        irda1: dataArray[5],
        irda2: dataArray[6],
        irda3: dataArray[7],
        irda4: dataArray[8],
        temp1: dataArray[9],
        temp2: dataArray[10],
        temp3: dataArray[11],
        temp4: dataArray[12],
        temp5: dataArray[13],
        temp6: dataArray[14],
        input1: dataArray[15],
        input2: dataArray[16],
        input3: dataArray[17],
        input4: dataArray[18],
        input5: dataArray[19],
        input6: dataArray[20],
        humidity1: dataArray[21],
        voltageInput: dataArray[22],
        Power: dataArray[23]
    }
}

const testRequestsFunction = async() => {
    const currentDate = parseInt((Date.now() / 1000).toFixed(0)) + 3600;
    const day = 2592000 / 30;

    let finalValues: any[] = []

    const tmp = Array.from({ length: 30 }, (_, index) => index + 1).reverse();
    const user = await Auth.currentAuthenticatedUser();
    const value = localStorage.getItem(`${user.username}.values`)

    // if (typeof value === 'string') {
    //     const parsedValues = JSON.parse(value) // ok
    //     return parsedValues
    // }

    for (let i = 30; i > 2; i = i - 3) {
        console.log('item: ', i)
        const data = await getDataByQuery(currentDate - (i*day), currentDate - ((i-3) * day));
        finalValues = [...finalValues, ...data as any[]]
    }
    console.log('finalValues step 1: ', [...finalValues])
    const data2 = await getDataByQuery(currentDate - (2*day) , currentDate);
        finalValues = [...finalValues, ...data2 as any[]]
    // Using for...of to iterate over the array and await each promise in sequence
    // for (const item of tmp) {
    //     const data = await getData(currentDate - (item*day), currentDate - ((item-1) * day));
    //     finalValues = [...finalValues, ...data as any[]]
    // }

    const sortedFinalValues = _.sortBy(finalValues, ['timestamp'])
    console.log('sortedFinalValues: ', sortedFinalValues.length)
    return sortedFinalValues
}

export const getDataFromLastMonth = () => {
    const currentDate = parseInt((Date.now() / 1000).toFixed(0)) + 3600;
    const oneMonth = 2592000;
    const quarterOfMonth = oneMonth / 4;
    const promises = [];
    const day = 2592000 / 30;
    return testRequestsFunction().then((res) => res)
    // try {
    //     console.log('logger: ', localStorage.getItem(`tomek_test`))
    //     const tmp = JSON.parse(localStorage.getItem(`tomek_test`) as any);
    //     if (tmp?.test === 'on') {
    //         return testRequestsFunction().then((res) => res)
    //     } else {
    //         for (let i = 30; i > 3; i = i - 4) {
    //             promises.push(getDataByQuery(currentDate - (i*day), currentDate - ((i-4) * day)))
    //         }
    //         return Promise.all(promises)
    //             .then((results) => {
    //                 // Flatten the array of results and return
    //                 return results.flat();
    //             });
    //     }
        
    // } catch (e) {
    //     for (let i = 30; i > 6; i = i - 7) {
    //         promises.push(getData(currentDate - (i*day), currentDate - ((i-7) * day)))
    //     }
    //     return Promise.all(promises)
    //         .then((results) => {
    //             // Flatten the array of results and return
    //             return results.flat();
    //         });
    // }
    // return Promise.all([
    //     getData(currentDate - oneMonth, currentDate - oneMonth + quarterOfMonth),
    //     getData(currentDate - oneMonth + quarterOfMonth + 1, currentDate - oneMonth + (2 * quarterOfMonth)),
    //     getData(currentDate - oneMonth + (2*quarterOfMonth) + 1, currentDate - oneMonth + (3 * quarterOfMonth)),
    //     getData(currentDate - oneMonth + (3*quarterOfMonth) + 1, currentDate)
    // ])
    //     .then((res) => {

    //         return res[0].concat(res[1]).concat(res[2]).concat(res[3]);
    //     });
}

export const getDataByQuery = async(startDate: number, endDate: number) => {
    const user = await Auth.currentAuthenticatedUser();

    return axios.get('/GetDevicesByNameQuery', _.assign(defaultConfig, {
        headers: {
            'Content-Type': 'application/json',
            'username': user.username
        },
        timeout: 1200000
    }, {
        params: {
            minDate: startDate,
            maxDate: endDate
        }
    })).then((res) => {
        return Promise.resolve(convertLastMonthResponse(res.data));
    })
    // return get('/GetDeviceData', {
    //     startDate,
    //     endDate
    // }).then(
    //     (res) => {
    //         return Promise.resolve(convertLastMonthResponse(res.data));
    //     }
    // )
}

export const getData = async(startDate: number, endDate: number) => {
    const user = await Auth.currentAuthenticatedUser();

    return axios.get('/GetDevicesDataByName', _.assign(defaultConfig, {
        headers: {
            'Content-Type': 'application/json',
            'username': user.username
        },
        timeout: 1200000
    }, {
        params: {
            minDate: startDate,
            maxDate: endDate
        }
    })).then((res) => {
        return Promise.resolve(convertLastMonthResponse(res.data));
    })
    // return get('/GetDeviceData', {
    //     startDate,
    //     endDate
    // }).then(
    //     (res) => {
    //         return Promise.resolve(convertLastMonthResponse(res.data));
    //     }
    // )
}

export const testLambda = async() => {
    const user = await Auth.currentAuthenticatedUser();

    return axios.get('/testLambda2', _.assign(defaultConfig, {
        headers: {
            'Content-Type': 'application/json',
            'username': user.username
        }
    }))
}

const convertLastMonthResponse = (items: any[]): any[] => {
    return items.map((item) => {
        return {
            timestamp: item.timestamp,
            ...convertResponseLine(item.values)
        }
    })
}

const createDateParams = () => {
    const currentDate = parseInt((Date.now() / 1000).toFixed(0)) + 3600;
    const currentDateMinusMonth = parseInt((Date.now() / 1000).toFixed(0)) + 3600 - (3600 * 24 * 30)
    return {
        startDate: currentDateMinusMonth,
        endDate: currentDate
    }
}
